<div class="container mt-4">
  <h2 class="mb-3 text-center">Electrician Review Management</h2>

  <!-- <div class="mb-3 d-flex gap-2">
    <input
      type="text"
      class="form-control"
      placeholder="Filter by Electrician ID"
      [(ngModel)]="selectedElectricianId"
    />
    <button class="btn btn-primary" (click)="fetchReviewsByElectrician()">
      Filter
    </button>
    <button class="btn btn-secondary" (click)="fetchAllReviews()">Reset</button>
  </div> -->

  <div *ngIf="loading">Loading reviews...</div>
  <div class="mb-3">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button
          class="nav-link"
          [ngClass]="{ active: selectedTab === 'approved' }"
          (click)="selectedTab = 'approved'"
        >
          Approved
        </button>
      </li>
      <li class="nav-item">
        <button
          class="nav-link"
          [ngClass]="{ active: selectedTab === 'pending' }"
          (click)="selectedTab = 'pending'"
        >
          Pending Approval
        </button>
      </li>
    </ul>
  </div>

  <table class="table table-bordered" *ngIf="!loading && reviews.length">
    <thead>
      <tr>
        <th>ID</th>
        <th>Electrician Name</th>
        <th>User Name</th>
        <th>Rating</th>
        <th>Review Text</th>
        <th>Status</th>
        <th>Date</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let review of filteredReviews">
        <td>{{ review.id }}</td>
        <td>{{ review.electricianName }}</td>
        <td>{{ review.userId ? review.name : "Anonymous" }}</td>
        <td>{{ review.rating }}</td>
        <td>{{ review.review }}</td>
        <td>{{ review.approved ? "Approved" : "Pending Approval" }}</td>
        <td>{{ review.createdAt | date : "short" }}</td>
        <td>
          <button
            class="btn btn-sm btn-warning"
            (click)="openEditModal(review)"
          >
            Edit
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="!loading && !reviews.length">
    <p>No reviews available.</p>
  </div>
  <nav
    *ngIf="totalPages > 1"
    class="mt-3 d-flex justify-content-center align-items-center"
  >
    <ul class="pagination">
      <!-- Previous -->
      <li class="page-item" [class.disabled]="page === 0">
        <button
          class="page-link"
          (click)="goToPage(page - 1)"
          [disabled]="page === 0"
        >
          Previous
        </button>
      </li>

      <!-- Pages 1, 2, 3 -->
      <ng-container *ngFor="let i of getPageArray(); let idx = index">
        <li class="page-item" [class.active]="i === page">
          <button class="page-link" (click)="goToPage(i)">{{ i + 1 }}</button>
        </li>
      </ng-container>

      <!-- Ellipsis if needed -->
      <li class="page-item disabled" *ngIf="shouldShowEllipsis()">
        <span class="page-link">...</span>
      </li>

      <!-- Last page -->
      <li
        class="page-item"
        *ngIf="shouldShowLastPage()"
        [class.active]="page === totalPages - 1"
      >
        <button class="page-link" (click)="goToPage(totalPages - 1)">
          {{ totalPages }}
        </button>
      </li>

      <!-- Next -->
      <li class="page-item" [class.disabled]="page >= totalPages - 1">
        <button
          class="page-link"
          (click)="goToPage(page + 1)"
          [disabled]="page >= totalPages - 1"
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

<!-- Edit Modal -->
<div class="modal-backdrop" *ngIf="showModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content p-3">
      <div class="modal-header d-flex">
        <h5 class="modal-title col-7">Edit Review</h5>
        <button
          type="button"
          class="btn-close col-1"
          (click)="closeModal()"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="editForm" (ngSubmit)="saveReview()">
          <div class="mb-3">
            <label for="rating" class="form-label">Rating</label>
            <input
              type="number"
              class="form-control"
              formControlName="rating"
              min="1"
              max="5"
            />
          </div>
          <div class="mb-3">
            <label for="review" class="form-label">Review</label>
            <textarea
              class="form-control"
              rows="3"
              formControlName="review"
            ></textarea>
          </div>
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="status"
              formControlName="status"
            />
            <label class="form-check-label" for="status">Approved</label>
          </div>
          <div class="d-flex gap-2 col-12 justify-content-between">
            <div
              type="submit"
              class="btn-primary col-4 bg-green text-center text-white rounded-2"
              role="button"
              (click)="saveReview()"
            >
              Save
            </div>
            <div
              type="button"
              class="btn-secondary ms-2 col-4 bg-danger text-center text-white rounded-2"
              (click)="closeModal()"
            >
              Cancel
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
  }
</style>
